import React, { useMemo } from "react";
import "./PaginationBar.css";

function buildPageButtons(page, totalPages) {
  const tp = Math.max(1, Number(totalPages || 1));
  const cur = Math.min(tp, Math.max(1, Number(page || 1)));

  if (tp <= 12) return Array.from({ length: tp }, (_, i) => i + 1);

  const out = [];
  const add = (v) => out.push(v);
  const addRange = (a, b) => {
    for (let i = a; i <= b; i += 1) add(i);
  };

  add(1);
  if (cur > 4) add("…");
  addRange(Math.max(2, cur - 2), Math.min(tp - 1, cur + 2));
  if (cur < tp - 3) add("…");
  add(tp);

  // de-dup (in case of overlaps)
  return out.filter((v, idx) => idx === 0 || v !== out[idx - 1]);
}

/**
 * Shared pagination UI component.
 */
export default function PaginationBar({
  page,
  totalCount,
  pageSize,
  itemsOnPage,
  onPageChange,
}) {
  const safePageSize = Math.max(1, Number(pageSize || 25));
  const safeTotalCount = Math.max(0, Number(totalCount || 0));
  const safePage = Math.max(1, Number(page || 1));

  const totalPages = Math.max(1, Math.ceil(safeTotalCount / safePageSize));
  const buttons = useMemo(() => buildPageButtons(safePage, totalPages), [safePage, totalPages]);

  if (!safeTotalCount) return null;

  const safeItemsOnPage = Math.max(0, Number(itemsOnPage ?? 0));
  const start = (safePage - 1) * safePageSize + 1;
  const end = Math.min((safePage - 1) * safePageSize + safeItemsOnPage, safeTotalCount);

  return (
    <div className="pagination-wrap">
      <div className="pagination-meta">
        Показано{" "}
        <span className="mono">
          {start}–{end}
        </span>{" "}
        из <span className="mono">{safeTotalCount}</span>
      </div>
      <div className="pagination-btns">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, safePage - 1))}
          className={`page-btn${safePage === 1 ? ' page-btn-disabled' : ''}`}
          disabled={safePage === 1}
        >
          ←
        </button>
        {buttons.map((p, idx) =>
          p === "…" ? (
            <span key={`dots-${idx}`} className="page-dots">
              …
            </span>
          ) : (
            <button
              key={p}
              type="button"
              onClick={() => onPageChange(p)}
              className={`page-btn${p === safePage ? ' page-btn-active' : ''}`}
            >
              {p}
            </button>
          )
        )}
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, safePage + 1))}
          className={`page-btn${safePage === totalPages ? ' page-btn-disabled' : ''}`}
          disabled={safePage === totalPages}
        >
          →
        </button>
      </div>
    </div>
  );
}

